/**
 * ToggleScroll
 * @param disableScroll boolean
 * Disables scrolling when set as true, enables it when set as false
 *
 * @returns
 * Toggles scrolling either by removing or adding overflowY = 'hidden' to the body tag.
 */

// modern Chrome requires { passive: false } when adding event
const supportsPassive = true;

const preventDefault = (e: Event): void => {
    e.preventDefault();
};

const wheelOpt = supportsPassive ? { passive: false } : false;
const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

const ToggleScroll = (disableScroll: boolean): void => {
    const BODY_ELEMENT = document.querySelector('body');
    if (!BODY_ELEMENT) {
        return;
    }
    if (disableScroll) {
        window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
        window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
        window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
    } else {
        window.removeEventListener('DOMMouseScroll', preventDefault, false);
        window.removeEventListener(wheelEvent, preventDefault);
        window.removeEventListener('touchmove', preventDefault);
    }
};


export default ToggleScroll;
